import { getEmploymentTypeList } from '@/api/employmentTypes';
import { useApiQuery } from '@/hooks/api';
import { REFERENCE_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { EmploymentType } from '@/types/employmentType';

export function useEmploymentTypesQuery(options?: { enabled?: boolean }) {
  const { enabled = true } = options ?? {};

  return useApiQuery<EmploymentType[]>({
    queryKey: queryKeys.employmentTypes.list(),
    queryFn: () => getEmploymentTypeList(),
    enabled,
    staleTime: REFERENCE_STALE_TIME,
  });
}
